<template>
   <v-row class="d-flex justify-center" no-gutters>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="">
            <v-row class="mt-4 px-4 justify-center">
                <v-col cols="12" xs="12" sm="5" md="5" lg="5" xl="5"> 
                    <div class="heading6 secondary--text">Reset Password</div>
                    <p class="mt-3 mb-0 text-left body2">Please enter your email address to request a password reset.</p>
                    <v-divider></v-divider>
                </v-col> 
            </v-row>
            <v-row class="d-flex justify-center mt-1">
                <v-col cols="12" xs="12" sm="5" md="5" lg="5" xl="5"> 
                    <firebase-auth-reset />
                </v-col>
            </v-row>         
        </v-col>     
    </v-row>    
</template>

<script>
export default {
  name: "ResetPassword",
};
</script>
